import {SwiperListBaseModel} from "./swiper-list-base.model";

export abstract class ApiListBaseModel extends SwiperListBaseModel {
    protected get _isAISorted(): boolean {
        return false;
    }
}